<template>
    <div>
        <!-- >>> Begin:Upper Banner -->
        <div class="banner imagebg-container" style="height: 350px; background-image: url(/res/images/complaints/complaints-banner.jpg);">
            <div class="container">
            <h1 class="big-caption">{{ bannerline1[getCurrentLocale] }}</h1>
            <h2 class="med-caption yellow-color">{{ bannerline2[getCurrentLocale] }}</h2>
            </div>
        </div>
        <!-- <<< End:Upper Banner -->


        <!-- Begin:PageContent -->
        <section id="content">
            <div class="container">
                <div class="row">
                    <!-- Begin:Page -->
                    <div id="main" class="col-md-9" v-show="sentSuccessful === false">
                        <div class="container shortcode travel-ideas">
                            <h1 class="idea-title"><span class="index"><i class="soap-icon-star circle"></i></span>{{ titleinfo[getCurrentLocale] }}</h1>
                        </div>
                        <br />


                        <div class="sdr-box booking-section">
                            <h3>{{ welcome[getCurrentLocale] }}</h3>
                            <p v-html="welcometext1[getCurrentLocale]"></p>
                            <br />
                            <p v-html="welcometext2[getCurrentLocale]"></p>
                            <br />
                            <p v-html="welcometext3[getCurrentLocale]"></p>
                        </div>


                        <br/>


                        <div class="sdr-box booking-section">
                            <form role="form" id="complaints-form" method="post" enctype="multipart/form-data" @submit.prevent="onSubmit">
                                <h2>{{ personaldata[getCurrentLocale] }}:</h2>

                                <!-- >>> row: firstname, lastname (val:ok) -->
                                <div class="form-group row">
                                    <div class="col-sm-6 col-md-5">
                                        <label>{{ label_firstname[getCurrentLocale] }}:*<small></small></label>
                                        <input type="text" class="input-text full-width"
                                            :class="{ invalid : $v.inputComplaint_firstname.$error }"
                                            @input="$v.inputComplaint_firstname.$touch()"
                                            v-model="inputComplaint_firstname"
                                            id="inputComplaint_firstname"
                                            name="inputComplaint_firstname"
                                            :placeholder="placeholder_firstname[getCurrentLocale]" />
                                        <!-- >>> 'errormsg', firstname -->
                                        <p class="errormsg" v-if="$v.inputComplaint_firstname.$dirty && !$v.inputComplaint_firstname.required">{{ errmsg_required[getCurrentLocale] }}</p>
                                        <p class="errormsg" v-if="$v.inputComplaint_firstname.$dirty && !$v.inputComplaint_firstname.minLength">{{ errmsg_min_firstname[getCurrentLocale] }}</p>
                                        <p class="errormsg" v-if="$v.inputComplaint_firstname.$dirty && !$v.inputComplaint_firstname.maxLength">{{ errmsg_max_firstname[getCurrentLocale] }}</p>
                                        <p class="errormsg" v-if="$v.inputComplaint_firstname.$dirty && !$v.inputComplaint_firstname.letterspaces">{{ errmsg_letterspaces[getCurrentLocale] }}</p>
                                        <!-- <<< 'errormsg', firstname -->
                                    </div>
                                    <div class="col-sm-6 col-md-5">
                                        <label>{{ label_lastname[getCurrentLocale] }}:*<small></small></label>
                                        <input type="text" class="input-text full-width"
                                            :class="{ invalid : $v.inputComplaint_lastname.$error }"
                                            @input="$v.inputComplaint_lastname.$touch()"
                                            v-model="inputComplaint_lastname"
                                            id="inputComplaint_lastname"
                                            name="inputComplaint_lastname"
                                            :placeholder="placeholder_lastname[getCurrentLocale]" />
                                        <!-- >>> 'errormsg', lastname -->
                                        <p class="errormsg" v-if="$v.inputComplaint_lastname.$dirty && !$v.inputComplaint_lastname.required">{{ errmsg_required[getCurrentLocale] }}</p>
                                        <p class="errormsg" v-if="$v.inputComplaint_lastname.$dirty && !$v.inputComplaint_lastname.minLength">{{ errmsg_min_firstname[getCurrentLocale] }}</p>
                                        <p class="errormsg" v-if="$v.inputComplaint_lastname.$dirty && !$v.inputComplaint_lastname.maxLength">{{ errmsg_max_firstname[getCurrentLocale] }}</p>
                                        <p class="errormsg" v-if="$v.inputComplaint_lastname.$dirty && !$v.inputComplaint_lastname.letterspaces">{{ errmsg_letterspaces[getCurrentLocale] }}</p>
                                        <!-- <<< 'errormsg', lastname -->
                                    </div>
                                </div>
                                <!-- <<< row: firstname (val:ok) -->

                                <!-- >>> row: email, emailrepeat (val:ok) -->
                                <div class="form-group row">
                                    <div class="col-sm-6 col-md-5">
                                        <label>{{ label_email[getCurrentLocale] }}:*<small></small></label>
                                        <input type="text" class="input-text full-width"
                                            :class="{ invalid : $v.inputComplaint_email.$error }"
                                            @input="$v.inputComplaint_email.$touch()"
                                            v-model="inputComplaint_email"
                                            id="inputComplaint_email"
                                            name="inputComplaint_email"
                                            :placeholder="placeholder_email[getCurrentLocale]" />
                                        <!-- >>> 'errormsg', email -->
                                        <p class="errormsg" v-if="$v.inputComplaint_email.$dirty && !$v.inputComplaint_email.required">{{ errmsg_required[getCurrentLocale] }}</p>
                                        <p class="errormsg" v-if="!$v.inputComplaint_email.email">{{ errmsg_email[getCurrentLocale] }}</p>
                                        <!-- <<< 'errormsg', email -->
                                    </div>
                                    <div class="col-sm-6 col-md-5">
                                        <label>{{ label_emailrepeat[getCurrentLocale] }}:*<small></small></label>
                                        <input type="text" class="input-text full-width"
                                            :class="{ invalid : $v.inputComplaint_emailrepeat.$error }"
                                            @input="$v.inputComplaint_emailrepeat.$touch()"
                                            v-model="inputComplaint_emailrepeat"
                                            id="inputComplaint_emailrepeat"
                                            name="inputComplaint_emailrepeat"
                                            :placeholder="placeholder_emailrepeat[getCurrentLocale]" />
                                        <!-- >>> 'errormsg', emailrepeat -->
                                        <p class="errormsg" v-if="$v.inputComplaint_emailrepeat.$dirty && !$v.inputComplaint_emailrepeat.required">{{ errmsg_required[getCurrentLocale] }}</p>
                                        <p class="errormsg" v-if="!$v.inputComplaint_emailrepeat.email">{{ errmsg_email[getCurrentLocale] }}</p>
                                        <!-- <<< 'errormsg', emailrepeat -->
                                    </div>
                                </div>
                                <!-- <<< row: email, emailrepeat (val:ok) -->

                                <!-- >>> row: zip, adress (val:ok) -->
                                <div class="form-group row">
                                    <div class="col-sm-6 col-md-5">
                                        <label>{{ label_zip[getCurrentLocale] }}:*<small></small></label>
                                        <input type="text" class="input-text full-width"
                                            :class="{ invalid : $v.inputComplaint_zip.$error }"
                                            @input="$v.inputComplaint_zip.$touch()"
                                            v-model="inputComplaint_zip"
                                            id="inputComplaint_zip"
                                            name="inputComplaint_zip"
                                            :placeholder="placeholder_zip[getCurrentLocale]" />
                                        <!-- >>> 'errormsg', zip -->
                                        <p class="errormsg" v-if="$v.inputComplaint_zip.$dirty && !$v.inputComplaint_zip.required">{{ errmsg_required[getCurrentLocale] }}</p>
                                        <p class="errormsg" v-if="$v.inputComplaint_zip.$dirty && !$v.inputComplaint_zip.numeric">{{ errmsg_numeric[getCurrentLocale] }}</p>
                                        <p class="errormsg" v-if="$v.inputComplaint_zip.$dirty && !$v.inputComplaint_zip.minLength">{{ errmsg_min_plz[getCurrentLocale] }}</p>
                                        <p class="errormsg" v-if="$v.inputComplaint_zip.$dirty && !$v.inputComplaint_zip.maxLength">{{ errmsg_max_plz[getCurrentLocale] }}</p>
                                        <!-- <<< 'errormsg', zip -->
                                    </div>
                                    <div class="col-sm-6 col-md-5">
                                        <label>{{ label_adress[getCurrentLocale] }}:*<small></small></label>
                                        <input type="text" class="input-text full-width"
                                            :class="{ invalid : $v.inputComplaint_adress.$error }"
                                            @input="$v.inputComplaint_adress.$touch()"
                                            v-model="inputComplaint_adress"
                                            id="inputComplaint_adress"
                                            name="inputComplaint_adress"
                                            :placeholder="placeholder_adress[getCurrentLocale]" />
                                        <!-- >>> 'errormsg', place -->
                                        <p class="errormsg" v-if="$v.inputComplaint_adress.$dirty && !$v.inputComplaint_adress.required">{{ errmsg_required[getCurrentLocale] }}</p>
                                        <!-- <<< 'errormsg', place -->
                                    </div>
                                </div>
                                <!-- <<< row: zip, adress (val:ok) -->

                                <!-- >>> row: departuredate, flightno (val:ok) -->
                                <div class="form-group row">
                                    <div class="col-sm-6 col-md-5">
                                        <label>{{ label_departuredate[getCurrentLocale] }}:*<small></small></label>
                                        <input type="text" class="input-text full-width"
                                            :class="{ invalid : $v.inputComplaint_departuredate.$error }"
                                            @input="$v.inputComplaint_departuredate.$touch()"
                                            v-model="inputComplaint_departuredate"
                                            id="inputComplaint_departuredate"
                                            name="inputComplaint_departuredate"
                                            :placeholder="placeholder_departuredate[getCurrentLocale]" />
                                        <!-- >>> 'errormsg', departuredate -->
                                        <p class="errormsg" v-if="$v.inputComplaint_departuredate.$dirty && !$v.inputComplaint_departuredate.required">{{ errmsg_required[getCurrentLocale] }}</p>
                                        <!-- <<< 'errormsg', departuredate -->
                                    </div>
                                    <div class="col-sm-6 col-md-5">
                                        <label>{{ label_flightno[getCurrentLocale] }}:*<small></small></label>
                                        <input type="text" class="input-text full-width"
                                            :class="{ invalid : $v.inputComplaint_flightno.$error }"
                                            @input="$v.inputComplaint_flightno.$touch()"
                                            v-model="inputComplaint_flightno"
                                            id="inputComplaint_flightno"
                                            name="inputComplaint_flightno"
                                            :placeholder="placeholder_flightno[getCurrentLocale]" />
                                        <!-- >>> 'errormsg', flightno -->
                                        <p class="errormsg" v-if="$v.inputComplaint_flightno.$dirty && !$v.inputComplaint_flightno.required">{{ errmsg_required[getCurrentLocale] }}</p>
                                        <!-- <<< 'errormsg', flightno -->
                                    </div>
                                </div>
                                <!-- <<< row: departuredate, flightno -->

                                <!-- >>> row: departureairport, destinationairport (val:ok) -->
                                <div class="form-group row">
                                    <div class="col-sm-6 col-md-5">
                                        <label>{{ label_departureairport[getCurrentLocale] }}:*<small></small></label>
                                        <input type="text" class="input-text full-width"
                                            :class="{ invalid : $v.inputComplaint_departureairport.$error }"
                                            @input="$v.inputComplaint_departureairport.$touch()"
                                            v-model="inputComplaint_departureairport"
                                            id="inputComplaint_departureairport"
                                            name="inputComplaint_departureairport"
                                            :placeholder="placeholder_departureairport[getCurrentLocale]" />
                                        <!-- >>> 'errormsg', departureairport -->
                                        <p class="errormsg" v-if="$v.inputComplaint_departureairport.$dirty && !$v.inputComplaint_departureairport.required">{{ errmsg_required[getCurrentLocale] }}</p>
                                        <!-- <<< 'errormsg', departureairport -->
                                    </div>
                                    <div class="col-sm-6 col-md-5">
                                        <label>{{ label_destinationairport[getCurrentLocale] }}:*<small></small></label>
                                        <input type="text" class="input-text full-width"
                                            :class="{ invalid : $v.inputComplaint_destinationairport.$error }"
                                            @input="$v.inputComplaint_destinationairport.$touch()"
                                            v-model="inputComplaint_destinationairport"
                                            id="inputComplaint_destinationairport"
                                            name="inputComplaint_destinationairport"
                                            :placeholder="placeholder_destinationairport[getCurrentLocale]" />
                                        <!-- >>> 'errormsg', destinationairport -->
                                        <p class="errormsg" v-if="$v.inputComplaint_destinationairport.$dirty && !$v.inputComplaint_destinationairport.required">{{ errmsg_required[getCurrentLocale] }}</p>
                                        <!-- <<< 'errormsg', destinationairport -->
                                    </div>
                                </div>
                                <!-- <<< row: departureairport, destinationairport -->

                                <!-- >>> row: remark -->
                                <div class="form-group row">
                                    <div class="col-md-10">
                                        <label>{{ label_remark[getCurrentLocale] }}:*<small></small></label>
                                        <textarea class="full-width" rows="10"
                                            :class="{ invalid : $v.inputComplaint_remark.$error }"
                                            @input="$v.inputComplaint_remark.$touch()"
                                            v-model="inputComplaint_remark"
                                            id="inputComplaint_remark"
                                            name="inputComplaint_remark"
                                            :placeholder="placeholder_remark[getCurrentLocale]"></textarea>
                                        <!-- >>> 'errormsg', remark -->
                                        <p class="errormsg" v-if="$v.inputComplaint_remark.$dirty && !$v.inputComplaint_remark.required">{{ errmsg_required[getCurrentLocale] }}</p>
                                        <!-- <<< 'errormsg', remark -->
                                    </div>
                                </div>
                                <!-- <<< row: remark -->

                                <!-- >>> row: file -->
                                <br />
                                <div class="form-group row">
                                    <div class="col-md-10">
                                        <label class="control-label" for="files" style="text-transform: none; font-weight: bold; font-size: 13px;">{{ label_file[getCurrentLocale] }}</label>
                                        <input type="file" accept="application/pdf" id="fileinput" name="fileinput" ref="fileinput" data-max-size="5096">
                                    </div>
                                </div>
                                <br />
                                <!-- <<< row: file -->




                                <div class="form-group row">
                                    <div class="col-sm-6 col-md-5">
			                            <div class="g-recaptcha" data-sitekey="6LexCygUAAAAAI5T46BeunRODXgfnj3rykC7jp3Y"></div>

                                        <a class="button btn-large uppercase full-width silver" v-if="!checkValidity()" style="margin-top:10px;">{{ send_request[getCurrentLocale] }}</a>
                                        <button type="submit" class="btn-large icon-check uppercase full-width" v-if="checkValidity()" style="margin-top:10px;">{{ send_request[getCurrentLocale] }}</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                    <div id="main" class="col-sm-8 col-md-9" v-show="sentSuccessful === true">
                        <div class="container shortcode travel-ideas">
                            <h1 class="idea-title"><span class="index"><i class="soap-icon-star circle"></i></span>{{ wasssentsuccesful[getCurrentLocale] }}</h1>
                        </div>
                    </div>
                    <!-- End:Page -->


                    <!-- Begin:Content-SideBar -->
                    <div class="sidebar col-md-3">
                        <sdr-aboutsundair-box></sdr-aboutsundair-box>
                        <sdr-contact-box></sdr-contact-box>
                    </div>
                    <!-- END:Content-SideBar -->
                </div>
            </div>
        </section>
        <!-- End:PageContent -->


        <!-- Begin:PromoBox -->
        <sdr-promobox></sdr-promobox>
        <!-- End:PromoBox -->
    </div>
</template>

<script>
    import AboutSundairBox from '../../shared/sidebar/AboutSundairBox.vue'; // Sidebar (right)
    import ContactBox from '../../shared/sidebar/ContactBox.vue'; // Sidebar (right)
    import PromoBox from '../../booking/pagecontent/PromoBox.vue';

    import { helpers, required, minLength, maxLength, numeric, alphaNum, email } from 'vuelidate/lib/validators';
    const letterspaces = helpers.regex('letterspaces', /^[a-z-öÖüÜäÄ\s]+$/i);    /* Validator */
    const numericspaces = helpers.regex('numericspaces', /^[0-9+/\s]+$/i);       /* Validator */

    import { mapGetters } from 'vuex';
    import { mapMutations } from 'vuex';
    import { mapActions } from 'vuex';
    import axios from 'axios';

    export default {

        /* >>> *************************************************************** / /* Components */
        components: {

            'sdr-aboutsundair-box': AboutSundairBox,
            'sdr-contact-box': ContactBox,
            'sdr-promobox': PromoBox,

        }, // eof components{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data: function() {

            return {
                bannerline1: {
                    en: 'You have a request?',
                    de: 'Sie haben ein Anliegen?',
                },
                now: {
                    en: 'With pleasure!',
                    de: 'Sehr gern!',
                },
                bannerline2: {
                    en: 'We will check it immediately.',
                    de: 'Wir prüfen es umgehend.',
                },
                // >>> ------------------------
                titleinfo: {
                    en: 'Complaints',
                    de: 'Reklamationen',
                },
                wasssentsuccesful : {
                    en: 'Successfully sent!',
                    de: 'Erfolgreich gesendet!',
                },
                // >>> --------------------------
                welcome: {
                    en: 'Welcome to the SUNDAIR Service Team',
                    de: 'Herzlich Willkommen beim SUNDAIR Serviceteam',
                },
                welcometext1: {
                    en: 'Dear passenger,<br /><br />We would like to apologize for the inconvenience caused.<br />Your possible requests or complaints can be sent quickly and easily using the online form.',
                    de: 'Sehr geehrter Fluggast,<br /><br />wir möchten uns bei Ihnen für die entstandenen Unannehmlichkeiten entschuldigen.<br />Ihre Reklamation bzw. Ihr Anliegen können Sie uns schnell und einfach über das Online-Formular übermitteln.',
                },
                welcometext2: {
                    en: 'Our goal is to:<br />- Check your request,<br />- to send you a reply as soon as possible',
                    de: 'Unser Ziel ist es:<br />- Ihr Anliegen zu prüfen,<br />- Ihnen schnellstmöglich eine Rückantwort zukommen zu lassen',
                },
                welcometext3: {
                    en: "Please don't forget to enter your contact details in the event of any queries.<br />A written version of the facts and the submission of the necessary documents will help us to record and examine your request.<br /><br />Many thanks",
                    de: 'Bitte hinterlegen Sie Ihre Kontaktdaten, damit wir uns im Falle von Rückfragen an Sie wenden können.<br />Eine schriftliche Ausführung des Sachverhaltes und die Übermittlung der notwendigen Unterlagen helfen uns bei der Erfassung und Prüfung Ihres Anliegens.<br /><br />Vielen Dank',
                },
                // >>> --------------------------
                personaldata: {
                    en: 'Personal Data',
                    de: 'Persönliche Daten',
                },
                // >>> --------------------------
                label_firstname: {
                    en: 'First name',
                    de: 'Vorname',
                },
                placeholder_firstname: {
                    en: 'Please enter your first name',
                    de: 'Bitte Ihren Vornamen eingeben',
                },
                label_lastname: {
                    en: 'Last name',
                    de: 'Nachname',
                },
                placeholder_lastname: {
                    en: 'Please enter your last name',
                    de: 'Bitte Ihren Nachnamen eingeben',
                },
                label_email: {
                    en: 'E-mail',
                    de: 'E-Mail',
                },
                placeholder_email: {
                    en: 'Please enter your e-mail',
                    de: 'Bitte Ihre E-Mail eingeben',
                },
                label_emailrepeat: {
                    en: 'E-mail (again)',
                    de: 'E-mail (wiederh.)',
                },
               placeholder_emailrepeat: {
                    en: 'Please enter your e-mail',
                    de: 'Bitte Ihre E-Mail eingeben',
                },
                label_zip: {
                    en: 'ZIP Code',
                    de: 'PLZ',
                },
                placeholder_zip: {
                    en: 'Please enter your zip code',
                    de: 'Bitte Ihre PLZ eingeben',
                },
                label_adress: {
                    en: 'Address',
                    de: 'Adresse',
                },
                placeholder_adress: {
                    en: 'Please enter your address',
                    de: 'Bitte Ihre Adresse eingeben',
                },
                label_departureairport: {
                    en: 'Departure airport',
                    de: 'Abflughafen',
                },
                placeholder_departureairport: {
                    en: 'Please enter your departure airport',
                    de: 'Bitte Ihren Abflughafen eingeben',
                },
                label_destinationairport: {
                    en: 'Destination Airport',
                    de: 'Zielflugafen',
                },
                placeholder_destinationairport: {
                    en: 'Please enter your destination airport',
                    de: 'Bitte Ihren Zielflughafen eingeben',
                },
                label_departuredate: {
                    en: 'Departure Date',
                    de: 'Abflugdatum',
                },
                placeholder_departuredate: {
                    en: 'Please enter your departure date',
                    de: 'Bitte Ihren Abflugdatum eingeben',
                },
                label_flightno: {
                    en: 'Flight no',
                    de: 'Flugnummer',
                },
                placeholder_flightno: {
                    en: 'Please enter your flight no',
                    de: 'Bitte Ihre Flugnummer eingeben',
                },
                label_remark: {
                    en: 'Message',
                    de: 'Nachricht',
                },
                placeholder_remark: {
                    en: 'Message to SUNDAIR',
                    de: 'Nachricht an SUNDAIR',
                },
                // >>> --------------------------
                label_file: {
                    en: 'Please select your file (*.pdf, max. 5 MB) with all flight-relevant documents (booking confirmation, flight tickets, flight schedule and/or flight time changes, confirmations of delays) for upload:',
                    de: 'Bitte wählen Sie Ihre Datei (*.pdf, max. 5 MB) mit allen flugrelevanten Dokumenten (Buchungsbestätigung, Flugtickets, Flugplan- und/oder Flugzeitenänderungen, Bestätigungen über Verspätungen) zum Upload aus: ',
                },
                // >>> --------------------------
                send_request: {
                    en: 'SEND MESSAGE',
                    de: 'NACHRICHT SENDEN',
                },
                // >>> --------------------------
                // >>> --------------------------
                errmsg_required: {
                    en: 'This Field must not be empty.',
                    de: 'Dieses Feld darf nicht leer sein.',
                },
                // >>> --------------------------
               errmsg_letterspaces: {
                    en: 'Letters, "-" and spaces are allowed.',
                    de: 'Erlaubt sind Buchstaben, “-“ und Leerzeichen.',
                },
                // >>> --------------------------
                errmsg_numericspaces: {
                    en: 'Numbers, "+/" and spaces are allowed.',
                    de: 'Erlaubt sind Zahlen, “+/“ und Leerzeichen.',
                },
                // >>> --------------------------
               errmsg_numeric: {
                    en: 'Only numbers are allowed.',
                    de: 'Es sind nur Zahlen erlaubt.',
                },
                errmsg_alphanum: {
                    en: 'Only numbers and letters are allowed.',
                    de: 'Erlaubt sind nur Zahlen und Buchstaben.',
                },
                // >>> --------------------------
                errmsg_min_firstname : {
                    en: 'Allowed length: 2-30 characters.',
                    de: 'Erlaubte Länge: 2-30 Zeichen.',
                },
                errmsg_max_firstname: {
                    en: 'Allowed length: 2-30 characters.',
                    de: 'Erlaubte Länge: 2-30 Zeichen.',
                },
                // >>> --------------------------
                errmsg_min_lastname : {
                    en: 'Allowed length: 2-60 characters.',
                    de: 'Erlaubte Länge: 2-60 Zeichen.',
                },
                errmsg_max_lastname: {
                    en: 'Allowed length: 2-60 characters.',
                    de: 'Erlaubte Länge: 2-60 Zeichen.',
                },
                // >>> --------------------------
                errmsg_email: {
                    en: 'Please provide valid Email.',
                    de: 'Bitte geben Sie eine gültige E-Mail an..',
                },
                // >>> --------------------------
                errmsg_min_plz : {
                    en: 'Allowed length: 4-8 characters.',
                    de: 'Erlaubte Länge: 4-8 Zeichen.',
                },
                errmsg_max_plz: {
                    en: 'Allowed length: 4-8 characters.',
                    de: 'Erlaubte Länge: 4-8 Zeichen.',
                },
                // >>> --------------------------
                // >>> --------------------------
                errmsg_pdf_1 : {
                    en: '.pdf file must not be larger than 5MB.',
                    de: '.pdf Datei darf nicht grösser als 5MB sein.',
                },
                errmsg_pdf_2 : {
                    en: 'Please upload only one file of type ".pdf".',
                    de: 'Bitte laden Sie nur eine Datei vom Typ ".pdf" hoch.',
                },
                errmsg_pdf_3 : {
                    en: 'Please select your .pdf to upload.',
                    de: 'Bitte wählen Sie Ihr .pdf zum Upload aus.',
                },
                errmsg_pdf_4 : {
                    en: 'Im not a robot. Please confirm.',
                    de: 'Bin bin kein Roboter. Bitte bestätigen.',
                },
                // >>> -------------------------- 'Form / Model / Vuelidate'
                inputComplaint_firstname: '',
                inputComplaint_email: '',
                inputComplaint_emailrepeat: '',
                inputComplaint_lastname: '',
                inputComplaint_zip: '',
                inputComplaint_adress: '',
                inputComplaint_departuredate: '',
                inputComplaint_flightno: '',
                inputComplaint_departureairport: '',
                inputComplaint_destinationairport: '',
                inputComplaint_remark: '',
                // >>> --------------------------------------------------------- SearchForm
                sentSuccessful: false
            };

        }, // eof data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Validations */
        validations: {

            inputComplaint_firstname: {
                required: required,
                minLength: minLength(2),
                maxLength: maxLength(30),
                letterspaces: letterspaces
            },
            inputComplaint_lastname: {
                required: required,
                minLength: minLength(2),
                maxLength: maxLength(30),
                letterspaces: letterspaces
            },
            inputComplaint_email: {
                required: required,
                email: email,
            },
            inputComplaint_emailrepeat: {
                required: required,
                email: email,
            },
            inputComplaint_zip: {
                required: required,
                numeric: numeric,
                minLength: minLength(4),
                maxLength: maxLength(8),
            },
            inputComplaint_adress: {
                required: required,
            },
            inputComplaint_departuredate: {
                required: required,
            },
            inputComplaint_flightno: {
                required: required,
            },
            inputComplaint_departureairport: {
                required: required,
            },
            inputComplaint_destinationairport: {
                required: required,
            },
            inputComplaint_remark: {
                required: required,
            },
        }, // eof validations{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'getCurrentLocale',
            ]),

        }, // eof computed{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods: {

            /******************************************************************* 'ServiceCalls - Common'
            * ServiceCalls:
            *******************************************************************/
            /*******************************************************************
            * Call::'/humanresources/complaint/' (PUT)
            *
            * Desc:  Saving 'Complaints'.
            * Note:
            *
            * @param {Object} requestParamObject (Params to send)
            * @return
            */
            call_saveComplaint(requestParamObject, file) {

                var me = this,
                    hdrs = '';


                me.$toc('>>> /infos/complaints/Home.vue >>> call_saveComplaint');
                // >>> Send Ajax Request ---------------------------------------
                this.convert_ToBase64(file, function(data) { // Convert it

                    requestParamObject.uploaddata = data.base64; // Add upload File
                    me.$vp_m();
                    axios.put('/humanresources/complaint/', requestParamObject)
                        .then(function(response) { // 'OK'
                            hdrs = response.headers["air41-status"];
                            switch (hdrs) {
                                case 'OK': // 'OK'
                                    me.$vp_um();
                                    me.sentSuccessful = true;
                                    break;
                                default: // 'ERROR'
                                    me.$toasted.global.sdr_app_error({
                                        message : response.headers["air41-error"]
                                    });
                                    break;
                            };
                        })
                        .catch(function(error) { // 'ERROR'
                            me.$vp_um();
                            me.$toasted.global.sdr_app_error({
                                message : 'Service unavailable'
                            });
                        });

                }.bind(this));

            }, // eof call_saveComplaint()





            /******************************************************************* 'Listeners - Common'
            * Listeners:
            *******************************************************************/
            /*******************************************************************
            * onSubmit()
            *
            * Desc: Form gets submitted.
            * Note:
            *
            * @param {Object} submitEvent (Event)
            * @return
            */
            onSubmit(submitEvent) {

                let me = this,
                    my_adress = null,
                    my_email1 = null,
                    my_email2 = null,
                    my_firstName = null,
                    my_lastName = null,
                    my_text = null,
                    my_zip = null,
                    my_flightdate = null,
                    my_flightno = null,
                    my_departureairport = null,
                    my_destinationairport = null,
                    requestParamObject = {},
                    formIsValid = true,
                    file = null,
                    extension = null,
                    isHuman = '';


                me.$toc('>>> /infos/complaints/Home.vue >>> onSubmit');
                // >>> File / Upload ------------------------------------------
                try {
                    file = me.$refs['fileinput'].files[0];
                } catch (err) {
                    file = "";
                    formIsValid = false;
                }

                if (file !== '' && file !== undefined) {
                    if(file.size > 5120000) { // 5000kb
                        me.$toasted.global.sdr_app_error({
                            message : me.errmsg_pdf_1[me.getCurrentLocale]
                        });
                        formIsValid = false;
                    }

                    if (formIsValid !== false) { // .pdf
                        extension = file.name.slice((file.name.lastIndexOf(".") - 1 >>> 0) + 2);
                        if(extension !== 'pdf') {
                            me.$toasted.global.sdr_app_error({
                                message : me.errmsg_pdf_2[me.getCurrentLocale]
                            });
                            formIsValid = false;
                        }
                    }
                } else {
                    me.$toasted.global.sdr_app_error({
                        message : me.errmsg_pdf_3[me.getCurrentLocale]
                    });
                }
                // <<< ---------------------------------------------------------


                // >>> Captcha -------------------------------------------------
                try {
                    isHuman = grecaptcha.getResponse();
                    formIsValid = true;
                } catch (err) {
                    isHuman = "";
                    formIsValid = false;
                }

                if (isHuman !== '') {
                    formIsValid = true;
                } else {
                    me.$toasted.global.sdr_app_error({
                        message : me.errmsg_pdf_4[me.getCurrentLocale]
                    });
                }
                // <<< ---------------------------------------------------------



                // >>> Build Object --------------------------------------------
                requestParamObject = {
                    "address" : submitEvent.target.elements['inputComplaint_adress'].value,
                    "email1" : submitEvent.target.elements['inputComplaint_email'].value,
                    "email2" : submitEvent.target.elements['inputComplaint_emailrepeat'].value,
                    "firstName" : submitEvent.target.elements['inputComplaint_firstname'].value,
                    "lastName" : submitEvent.target.elements['inputComplaint_lastname'].value,
                    "text" : submitEvent.target.elements['inputComplaint_remark'].value,
                    "zipCode" : submitEvent.target.elements['inputComplaint_zip'].value,
                    "flightDate" : submitEvent.target.elements['inputComplaint_departuredate'].value,
                    "flightNumber" : submitEvent.target.elements['inputComplaint_flightno'].value,
                    "departure" : submitEvent.target.elements['inputComplaint_departureairport'].value,
                    "destination" : submitEvent.target.elements['inputComplaint_destinationairport'].value,
                    "isHuman" : isHuman
                };


                if (requestParamObject !== '' && formIsValid === true) {
                   this.call_saveComplaint(requestParamObject, file);
                }

            }, // eof onSubmit()





            /*******************************************************************
            * Utilities:
            *******************************************************************/
            /*******************************************************************
            * checkValidity()
            *
            * Desc:
            * Note:
            *
            * @param
            * @return {Array}
            */
            checkValidity: function() {

                var me = this,
                    formIsValid = true;


                me.$toc('>>> /infos/complaintsg/Home.vue >>> checkValidity');
                if (formIsValid) {
                    if (me.$v.inputComplaint_firstname.$dirty && !me.$v.inputComplaint_firstname.$error) {
                        formIsValid = true;
                    } else {
                        formIsValid = false;
                    }
                }
                if (formIsValid) {
                    if (me.$v.inputComplaint_email.$dirty && !me.$v.inputComplaint_email.$error) {
                        formIsValid = true;
                    } else {
                        formIsValid = false;
                    }
                }
                if (formIsValid) {
                    if (me.$v.inputComplaint_emailrepeat.$dirty && !me.$v.inputComplaint_emailrepeat.$error) {
                        formIsValid = true;
                    } else {
                        formIsValid = false;
                    }
                }
                if (formIsValid) {
                    if (me.$v.inputComplaint_lastname.$dirty && !me.$v.inputComplaint_lastname.$error) {
                        formIsValid = true;
                    } else {
                        formIsValid = false;
                    }
                }
                if (formIsValid) {
                    if (me.$v.inputComplaint_zip.$dirty && !me.$v.inputComplaint_zip.$error) {
                        formIsValid = true;
                    } else {
                        formIsValid = false;
                    }
                }
                if (formIsValid) {
                    if (me.$v.inputComplaint_adress.$dirty && !me.$v.inputComplaint_adress.$error) {
                        formIsValid = true;
                    } else {
                        formIsValid = false;
                    }
                }
                if (formIsValid) {
                    if (me.$v.inputComplaint_departuredate.$dirty && !me.$v.inputComplaint_departuredate.$error) {
                        formIsValid = true;
                    } else {
                        formIsValid = false;
                    }
                }
                if (formIsValid) {
                    if (me.$v.inputComplaint_flightno.$dirty && !me.$v.inputComplaint_flightno.$error) {
                        formIsValid = true;
                    } else {
                        formIsValid = false;
                    }
                }
                if (formIsValid) {
                    if (me.$v.inputComplaint_departureairport.$dirty && !me.$v.inputComplaint_departureairport.$error) {
                        formIsValid = true;
                    } else {
                        formIsValid = false;
                    }
                }
                if (formIsValid) {
                    if (me.$v.inputComplaint_destinationairport.$dirty && !me.$v.inputComplaint_destinationairport.$error) {
                        formIsValid = true;
                    } else {
                        formIsValid = false;
                    }
                }
                if (formIsValid) {
                    if (me.$v.inputComplaint_remark.$dirty && !me.$v.inputComplaint_remark.$error) {
                        formIsValid = true;
                    } else {
                        formIsValid = false;
                    }
                }


                return formIsValid;

            }, // eof checkValidity()


            /*******************************************************************
            * convert_ToBase64
            *
            * Desc: Convert to Base64.
            *
            */
            convert_ToBase64: function(file, callback){

                var me = this,
                    reader = '',
                    coolFile = {};


                me.$toc('>>> /infos/complaintsg/Home.vue >>> checkValidity');
                // >>> ---------------------------------------------------------
                function readerOnload(e){
                    //var base64 = btoa(e.target.result);   // Older
                    var base64 = e.target.result;           // Newer

                    coolFile.base64 = base64;
                    callback(coolFile); // give it back
                };
                // <<< ---------------------------------------------------------

                reader = new FileReader();
                reader.onload = readerOnload;

                //var file = file[0].files[0];
                coolFile.filetype   = file.type;
                coolFile.size       = file.size;
                coolFile.filename   = file.name;

                //reader.readAsBinaryString(file);  // Older
                reader.readAsDataURL(file);         // Newer

            }, // eof convert_ToBase64()

        }, // eof methods()
        /* <<< ****************************************************************/

    };
</script>

<style scoped>
    .selector select {
        opacity: 1;
    }

    input:focus {
        outline: none;
    }
    input.input-text:focus, textarea:focus, .selector select:focus + .custom-select {
        outline: none;
        border: 1px solid #d3e4f7;
        box-shadow: 0 0 8px #d3e4f7;
    }

    input.input-text.invalid {
        border: 1px solid red;
        background-color: #fdecf8;
    }
    .selector select.invalid {
        border: 1px solid red;
    }

    .errormsg {
        margin-bottom: 3px;
        margin-top: 3px;
        color: red;
    }





    /* >>>  iPAD -------------------------------------------------------------*/
    @media only screen
    and (min-device-width : 768px)
    and (max-device-width : 1024px)  {
        h1 {
            font-size: 1.6em;
        }
        .booking-section{
            padding: 20px 30px 30px;
            padding-top: 20px;
            padding-right: 15px;
            padding-bottom: 30px;
            padding-left: 15px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/infos/complaints/Home.vue